import { createSlice } from "@reduxjs/toolkit";
import { boiDepartmentId } from "libs/configs/constant";
import HttpClient from "libs/utils/HttpClient";
import AuthService from "services/AuthService";
import Swal from "sweetalert2";

let initialState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  isOfflineLogin: false,
  accessToken: "",
  refreshToken: "",
  userID: "",
  role: "",
  error: null,
  currentRole: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearLoginAsyncState(state) {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFailure = false;
    },
    loginRequest(state, action) {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFailure = false;
      state.error = initialState.error;
    },
    loginSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.userID = action.payload.userID;
      state.role = action.payload.role;
      state.isOfflineLogin = action.payload.isOfflineLogin || false;
    },
    loginFailure(state, action) {
      state.isLoading = false;
      state.isFailure = true;
      state.error = action.payload;
    },
    RegisterFailure(state, action) {
      state.isLoading = false;
      state.isFailure = true;
      state.error = action.payload;
    },
    RegisterSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
    },
    refreshTokenRequest(state, action) {
      state.isLoading = true;
      state.error = initialState.error;
    },
    refreshTokenSuccess(state, action) {
      state.isLoading = false;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    refreshTokenFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    ForgotpasswordSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
    },
    ForgotpasswordFailure(state, action) {
      state.isLoading = false;
      state.isFailure = true;
      state.error = action.payload;
    },
    logout(state, action) {
      HttpClient.setToken(null);
      return initialState;
    },
    setCurrentUserRole(state, action) {
      state.currentRole = action.payload;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  RegisterFailure,
  logout,
  RegisterSuccess,
  ForgotpasswordSuccess,
  ForgotpasswordFailure,
  refreshTokenRequest,
  refreshTokenSuccess,
  refreshTokenFailure,
  clearLoginAsyncState,
  setCurrentUserRole,
} = authSlice.actions;

// ======== Thunk Action ==========

export function login(code, redirect_uri) {
  return async (dispatch) => {
    dispatch(loginRequest());
    try {
      const response = await AuthService.login(code, redirect_uri);
      const results = response?.results || {};

      HttpClient.setToken(results.accessToken);

      dispatch(loginSuccess(results));

      // Router.replace("/");
    } catch (error) {
      dispatch(loginFailure(error.message));
      alert("Opps!!! " + error.message);
      throw error;
    }
  };
}

export function loginNew(data) {
  return async (dispatch) => {
    dispatch(loginRequest());
    try {
      const response = await AuthService.loginNew(data);
      const results = response?.results || {};

      HttpClient.setToken(results.accessToken);

      dispatch(loginSuccess({ ...results }));

      // Router.replace("/");
    } catch (error) {
      dispatch(loginFailure(error.message));

      Swal.fire("Oops !", '"Error ! ", "Oops !" ' + error.message, "error");

      throw error;
    }
  };
}

export function Register(data) {
  return async (dispatch) => {
    console.log(data);
    // dispatch(loginRequest());
    try {
      const response = await AuthService.Register(data);
      const results = response?.results || {};

      // HttpClient.setToken(results.accessToken);

      alert("Please Activate in Email");

      dispatch(RegisterSuccess({ ...results }));

      // Router.replace("/");
    } catch (error) {
      dispatch(RegisterFailure(error.message));
      alert("Opps!!! " + error.message);
      throw error;
    }
  };
}

export function forgot_password(data) {
  return async (dispatch) => {
    try {
      const response = await AuthService.ForgotPassword(data);
      const results = response?.results || {};
      alert("Please Check email  !");

      dispatch(ForgotpasswordSuccess({ ...results }));

      // Router.replace("/");
    } catch (error) {
      dispatch(ForgotpasswordFailure(error.message));
      alert('Oops !" ' + error.message);

      throw error;
    }
  };
}

export function forgot_password_check(data) {
  return async (dispatch) => {
    try {
      const response = await AuthService.ForgotPasswordCheck(data);
      const results = response?.results || {};

      console.log(results);
      if (results.check) {
        alert("Success You can login By New Password    !");

        dispatch(ForgotpasswordSuccess({ ...results }));
      } else {
        alert("Not Found User ID Or Password not match   !");
      }
    } catch (error) {
      dispatch(ForgotpasswordFailure(error.message));
      alert('Oops !" ' + error.message);

      throw error;
    }
  };
}

export function loginOffline(username, password) {
  return async (dispatch) => {
    dispatch(loginRequest());
    try {
      const response = await AuthService.loginOffline(username, password);
      const results = response?.results || {};

      HttpClient.setToken(results.accessToken);

      dispatch(loginSuccess({ ...results, isOfflineLogin: true }));

      // Router.replace("/");
    } catch (error) {
      dispatch(loginFailure(error.message));
      alert("Opps!!! " + error.message);
      throw error;
    }
  };
}

export function refreshToken(isDisplayError = true) {
  return async (dispatch, getState) => {
    dispatch(refreshTokenRequest());
    try {
      const tokenRefresh = getState().auth.refreshToken;
      const response = await AuthService.refreshToken(tokenRefresh);
      const results = response?.results || {};

      HttpClient.setToken(results.accessToken);

      dispatch(refreshTokenSuccess(results));
    } catch (error) {
      dispatch(refreshTokenFailure(error.message));
      if (isDisplayError) {
        alert("Session expired!!", "Please try to login again.");
      }
      dispatch(logout());
      throw error;
    }
  };
}

export default authSlice.reducer;

export const selectIsAdmin = (state) => {
  const auth = state.auth;
  return auth.role === "Admin" ? true : false;
};

export const selectIsUser = (state) => {
  const auth = state.auth;
  return auth.role === "Admin" ? false : true;
};

export const selectIsBOI = (state) => {
  const auth = state.auth;
  const { departmentId } = state.user.profile;
  const isAdmin = auth.role === "Admin";
  const isBOI = departmentId === boiDepartmentId;
  return isAdmin && isBOI;
};

export const selectIsOtherDepartment = (state) => {
  const auth = state.auth;
  const { departmentId } = state.user.profile;
  const isAdmin = auth.role === "Admin";
  const isOtherDep = departmentId !== boiDepartmentId;
  return isAdmin && isOtherDep;
};

export const canEditForm = (state) => {
  const auth = state.auth;

  if (auth.role === "Admin") {
    return false;
  }

  return true;
};
